import 'leaflet-velocity'
import React from 'react'
import PropTypes from 'prop-types'
import 'leaflet-timedimension'
import {
    Container,
    Box,
    Typography,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Divider,
    CardHeader,
    Card,
    CardContent,
} from '@mui/material'
import DateUtils from '../../inumet_js_lib/utils/dateUtils'
import WaterIcon from '@mui/icons-material/Water'
import WarningIcon from '@mui/icons-material/Warning'

const AvisosMarino = ({ dataAvisos }) => {
    if (dataAvisos) {
        let itemsContent = []
        if (
            !dataAvisos.activo ||
            !dataAvisos.zonasDescripcion ||
            dataAvisos.zonasDescripcion.length === 0
        ) {
            itemsContent = (
                <Grid item xs={12} md={12} key={0}>
                    <Paper elevation={3} sx={{ p: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            No se formula
                        </Typography>
                    </Paper>
                </Grid>
            )
        } else {
            dataAvisos.zonasDescripcion.forEach((itemDataAviso, index) => {
                itemsContent.push(
                    <Grid item xs={12} md={12} key={index}>
                        <Paper elevation={3} sx={{ p: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                {itemDataAviso.zonaNombre} por{' '}
                                {itemDataAviso.tipo}
                            </Typography>
                            <Divider />
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <WarningIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={itemDataAviso.descripcion}
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>

                    /*<div key={index} style={{ marginLeft: 30 }}>
                        <h5 key={'primary'}>
                            <FAIcon mr={3} fas iconId={'location-dot'} />
                            <span>
                                Aviso en {itemDataAviso.zonaNombre} por{' '}
                                {itemDataAviso.tipo}
                            </span>
                        </h5>
                        <p>{itemDataAviso.descripcion}</p>
                    </div>*/
                )
            })
        }
        let fechaLTIniValidez =
            dataAvisos.fechaInicioValidez + ' ' + dataAvisos.horaInicioValidez
        let utcIniValidez = DateUtils.addHours(fechaLTIniValidez, 3)
        let fechaStr =
            DateUtils.latinDT(fechaLTIniValidez) +
            ' (' +
            DateUtils.latinDT(utcIniValidez) +
            ' UTC)'

        return (
            <Container>
                <Box mt={4} mb={4} textAlign="center">
                    <Typography variant="h4" gutterBottom>
                        Instituto Uruguayo de Meteorología
                    </Typography>
                    <Typography variant="subtitle1">
                        Área de Meteorología y Clima para la Sociedad
                    </Typography>
                    <Typography variant="subtitle1">
                        División Servicios Meteorológicos Departamento
                    </Typography>
                    <Typography variant="subtitle1">
                        Pronóstico del Tiempo y Vigilancia Meteorológica
                    </Typography>
                </Box>

                <Card variant="outlined" sx={{ mb: 4 }}>
                    <CardHeader
                        avatar={<WaterIcon />}
                        title={`Situación Sinóptica - ${fechaStr}`}
                        titleTypographyProps={{ variant: 'h6' }}
                    />
                    <CardContent>
                        <Typography variant="body1">
                            {dataAvisos.situacionSinoptica}
                        </Typography>
                    </CardContent>
                </Card>

                <Card variant="outlined" sx={{ mb: 4 }}>
                    <CardHeader
                        avatar={<WarningIcon />}
                        title={`Avisos - ${fechaStr}`}
                        titleTypographyProps={{ variant: 'h6' }}
                    />
                    <CardContent>
                        <Grid container spacing={4}>
                            {itemsContent}
                        </Grid>
                    </CardContent>
                    <Typography variant="body2" paragraph>
                        La Situación Sinóptica en superficie y Avisos se
                        actualizarán 4 veces al día, en los siguientes horarios:
                        00, 06, 12 y 18 hora local (03, 09, 15 y 21 horario
                        UTC).
                    </Typography>
                </Card>
            </Container>
        )
    }

    return <></>
}

export default AvisosMarino

AvisosMarino.propTypes = {
    dataAvisos: PropTypes.object,
}
